export enum ValidationStatus {
    Empty = 0,
    Correct = 1,
    Incorrect = 2,
}